// extracted by mini-css-extract-plugin
export var catIcon = "DishItem-module--catIcon--WUkOY";
export var found = "DishItem-module--found--uGL0u";
export var iconWrapper = "DishItem-module--iconWrapper--8LBO6";
export var imageWrapper = "DishItem-module--imageWrapper--Y7skN";
export var noItems = "DishItem-module--noItems--KlxrM";
export var noteOrderStatus = "DishItem-module--noteOrderStatus--+OI72";
export var notfound = "DishItem-module--notfound--7MCPq";